import type { Holidays } from "@msuite/utils/holidays";
import { useTranslation } from "../localization";
import { Tooltip } from "../tooltip";
import { Tag } from "./tag";

/** Props Interface */
interface HolidayTagProps {
	/** biome-ignore lint: needed here */
	holiday: Holidays.Holiday | undefined | void;
	size?: "default" | "tiny";
}

export function HolidayTag({ holiday, size = "default" }: HolidayTagProps) {
	/** Hooks */
	const i18n = useTranslation();

	/** Guard */
	if (!holiday) return null;

	if (size === "tiny") {
		return (
			<Tooltip label={holiday.translate(i18n.language)}>
				<Tag
					color="blue"
					className="aspect-square"
					withPing
				/>
			</Tooltip>
		);
	}

	/** Render */
	return <Tag color="blue">{holiday.translate(i18n.language)}</Tag>;
}
